var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-layout zpa-column",class:_vm.className},[_c('zpa-row',{staticStyle:{"z-index":"9","margin-bottom":"-25px"},attrs:{"height":"auto"}},[_c('Box',[_vm._t("search")],2)],1),_c('zpa-column',[_c('Box',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }